<div class="position-relative text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Upload RDP and VNC File</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
  </div>
  <div class="modal-body">
    <form [formGroup]="templateFileForm" autocomplete="off" spellcheck="false">
      <h4 class="modal-title synchpc-primary" id="modal-title">Upload file</h4>
      <br />
      <div class="template-display">
        <mat-form-field appearance="fill" style="width: 60%">
          <mat-label>File Type</mat-label>
          <mat-select formControlName="fileTypeApp">
            <mat-option *ngFor="let type of fileTypes" [value]="type">
              {{ type.name }}
            </mat-option>
          </mat-select>
          <mat-hint>Please Select File Type Before Uploading</mat-hint>
        </mat-form-field>
        <input type="file"
               #chooseAppFile
               style="display: none;"
               (click)="onFileChange('chooseAppFile')"
               (change)="uploadFiles($event, 'userScriptFile')" />
        <button type="button"
                [disabled]="!templateFileForm.get('fileTypeApp').value"
                [ngStyle]="{'cursor': !templateFileForm.get('fileTypeApp').value ? 'not-allowed' : 'pointer' }"
                title="Select and upload file"
                 class="bi bi-cloud-arrow-up pull-right uploadBtn"
                (click)="chooseAppFile.click()">
          Upload File
        </button>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()">Update</button>
  </div>
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="default" zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="false"
               name="updateCredential"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
